// extracted by mini-css-extract-plugin
export var icon = "homepageAnimSvg-module--icon--Jsacs";
export var icon2 = "homepageAnimSvg-module--icon2--Qu9m6";
export var icon3 = "homepageAnimSvg-module--icon3--IoB6O";
export var icon4 = "homepageAnimSvg-module--icon4--NmMZR";
export var icon5 = "homepageAnimSvg-module--icon5--OBLEw";
export var icon6 = "homepageAnimSvg-module--icon6--eCoUt";
export var sbShowMain = "homepageAnimSvg-module--sb-show-main--B59Tw";
export var svg = "homepageAnimSvg-module--svg--w+MX1";